import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NavbarProps } from './Navbar.types';
import { NavLandmark, StyledMenu } from './Navbar.styles';
import { useNavbar } from './hooks/useNavbar';

const Navbar: FC<NavbarProps> = ({ role, collapsed = false }) => {
  const { t } = useTranslation();
  const { menuItems, onClick, current } = useNavbar({ role });

  return (
    <NavLandmark aria-label={t('primaryNavigation', { defaultValue: 'Primary' })}>
      <StyledMenu
        onClick={onClick}
        selectedKeys={[current]}
        items={menuItems}
        mode="inline"
        /* Without this antd keeps rendering full-width labels inside the
           80px rail: the text is clipped rather than hidden, and the icons
           never centre. It is also what applies the collapsed class the
           rail styling is written against. */
        inlineCollapsed={collapsed}
      />
    </NavLandmark>
  );
};

export default Navbar;
